import React from "react";
import { SimpleGrid, Box, Image, Paper, Text, Stack } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";

// Reusable PhotoStrip Component
interface IPhotoStripProps {
  photos: string[]; // Array of image URLs
  imageHeight?: number; // Customizable image height
  cols?: { base: number; sm: number; lg: number }; // Grid column configuration
  title?: string; // Optional title for the component
}

export const PhotoStrip: React.FC<IPhotoStripProps> = ({
  photos,
  imageHeight = 385, // Default image height can't exceed 385px
  cols = { base: 1, sm: 2, lg: 4 }, // Default grid layout
  title = "Photo Strip", // Default title
}) => {
  const { width } = useViewportSize();
  const adjustedImageHeight = width < 362 ? 300 : imageHeight;
  return (
    <Stack align="center" gap="lg">
      {/* Title */}
      <Paper withBorder shadow="md" p="xl" style={{ textAlign: "center" }} w={"100%"}>
        <Text size="lg" fw={500}>
          {title}
        </Text>
      </Paper>

      {/* Photo Strip Grid */}
      <Box
        style={{
          backgroundColor: "black",
          padding: "20px 10px",
          borderRadius: "8px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
          width: "auto",
          height: `${adjustedImageHeight}` ,
        }}
      >
        <SimpleGrid cols={cols} spacing="md">
          {photos.map((photo, index) => (
            <Box
              key={index}
              style={{
                backgroundColor: "white",
                padding: "8px",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                borderRadius: "4px",
              }}
            >
              <Image
                src={photo}
                alt={`Photo ${index + 1}`}
                h={adjustedImageHeight}
                w="auto"
              />
            </Box>
          ))}
        </SimpleGrid>
      </Box>
    </Stack>
  );
};
